import { IPLTeamLogos, QuestionType, QuestionTypeName } from "../../types/type";
import { MatchType } from "../MatchHeaderDropdown";
export type FormatResponse = {
  first: string;
  middle: string;
  last: string;
};
export type AnswerFormat = {
  isMatch: boolean;
  buttonText?: string;
  homeTeam?: string;
  awayTeam?: string;
  team?: MatchType;
};

export const formatQuestionWording = ({
  type,
}: {
  type: QuestionTypeName;
}): FormatResponse => {
  if (type === "WINNING_TEAM") {
    return { first: "Who will", middle: "win", last: "this match?" };
  } else if (type === "RUNS") {
    return { first: "How many", middle: "runs", last: "will be scored?" };
  } else if (type === "BOUNDARIES") {
    return { first: "How many", middle: "boundaries", last: "will be hit?" };
  } else {
    return { first: "How many", middle: "wickets", last: "will be taken?" };
  }
};

export function sortQuestionList(questionList: QuestionType[]): QuestionType[] {
  const order: { [key: string]: number } = {
    WINNING_TEAM: 1,
    RUNS: 2,
    WICKETS: 3,
  };

  questionList.sort((a: QuestionType, b: QuestionType) => {
    return order[a.question_type_name] - order[b.question_type_name];
  });

  return questionList;
}

export const formatAnswer = ({
  question,
  team,
  above,
  isTeam,
  isPlus = false,
}: {
  question: QuestionType;
  team?: MatchType;
  above: boolean;
  isTeam?: boolean;
  isPlus?: boolean;
}): AnswerFormat => {
  if (
    isTeam !== null &&
    team &&
    question.question_type_name === "WINNING_TEAM"
  ) {
    return {
      homeTeam: team.home_team_abbreviation,
      awayTeam: team.away_team_abbreviation,
      isMatch: true,
      team: team,
    };
  } else {
    return {
      isMatch: false,
      buttonText: above
        ? isPlus
          ? question.benchmark_value + " or More"
          : question.benchmark_value + " or More"
        : question.benchmark_value - 1 + " or Less",
      team: team,
    };
  }
};
export const formatAnswerCapitalize = ({
  question,
  team,
  above,
  isTeam,
  isPlus = false,
}: {
  question: QuestionType;
  team?: MatchType;
  above: boolean;
  isTeam?: boolean;
  isPlus?: boolean;
}): AnswerFormat => {
  if (
    isTeam !== null &&
    team &&
    question.question_type_name === "WINNING_TEAM"
  ) {
    return {
      homeTeam: team.home_team_abbreviation,
      awayTeam: team.away_team_abbreviation,
      isMatch: true,
    };
  } else {
    return {
      isMatch: false,
      buttonText: above
        ? isPlus
          ? question.benchmark_value + "+"
          : question.benchmark_value + " or More"
        : question.benchmark_value - 1 + " or Less",
    };
  }
};
